export const paths = {
	kontaktOss: {
		forside: '/person/kontakt-oss',
	},
	tilbakemeldinger: {
		forside: '/tilbakemeldinger',
		serviceklage: {
			form: '/tilbakemeldinger/serviceklage',
		},
		feilogmangler: '/tilbakemeldinger/feil-og-mangler',
		rostilnav: '/tilbakemeldinger/ros-til-nav',
	},
};
